import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import DeleteTagModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tags/components/delete_tag_modal.vue?vue3';

export default function initDeleteTagModal() {
  const el = document.querySelector('.js-delete-tag-modal');
  if (!el) return false;

  return initVueApp({ el, name: 'DeleteTagModalRoot', component: DeleteTagModal });
}
